namespace B2B.UI {
    export class Utils {
        private static _desktopCurrentScrollTop: number;
        private static _mobileCurrentScrollTop: number;
        // ios popup fix https://css-tricks.com/prevent-page-scrolling-when-a-modal-is-open/
        public static fixBody() {
            if(Utils.isMobile()){
                Utils.fixBodyInternal();
            }
            //else{
            //    Utils.hideScroll();
            //}
        }

        public static unfixBody() {
            if(Utils.isMobile()){
                Utils.unfixBodyInternal();
            }
            //else{
            //    Utils.showScroll();
            //}
        }

        public static fixBodyInternal() {
            Utils._mobileCurrentScrollTop = window.scrollY;
            document.body.style.position = 'fixed';
            document.body.style.top = `-${window.scrollY}px`;
            document.body.style.left = '0px';
            document.body.style.right = '0px';
        }

        public static unfixBodyInternal() {
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.left = '';
            document.body.style.right = '';
            window.scrollTo(0, Utils._mobileCurrentScrollTop || 0);
        }

        public static isMobile(){
            return document.body.classList.contains("js-is-mobile");
        }

        // fix scroll for desktop
        private static hideScroll() {
            document.body.classList.add('no-scroll');
            Utils._desktopCurrentScrollTop = window.pageYOffset; // запоминаем текущую прокрутку сверху
            document.body.style.position = 'fixed';
            if ( Utils.hasScrollbar()) {
                // с учетом горизонтального скролла. Чтобы небыло рывка при открытии модального окна
                document.body.style.width = 'calc(100% - ' + Utils.getScrollbarSize() + 'px)';
            } else {
                document.body.style.width = '100%';
            }
            document.body.style.top = (-Utils._desktopCurrentScrollTop) + 'px';
        }

        private static showScroll() {
            document.body.classList.remove('no-scroll');
            document.body.style.position = '';
            document.body.style.width = '';
            document.body.style.top = '';
            window.scroll(0, Utils._desktopCurrentScrollTop);
        }

        private static getScrollbarSize() { // получение ширины скролла
            var outer = document.createElement('div');
            outer.style.visibility = 'hidden';
            outer.style.width = '100px';
            // @ts-ignore
            outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps

            document.body.appendChild(outer);

            var widthNoScroll = outer.offsetWidth;
            // force scrollbars
            outer.style.overflow = 'scroll';

            // add innerdiv
            var inner = document.createElement('div');
            inner.style.width = '100%';
            outer.appendChild(inner);

            var widthWithScroll = inner.offsetWidth;

            // remove divs
            outer.parentNode.removeChild(outer);
            return widthNoScroll - widthWithScroll;
        }

        private static hasScrollbar() : boolean { // проверка на боковой скролл
            return document.body.scrollHeight > document.body.clientHeight;
        }
    }
}